import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import Toggle from 'material-ui/Toggle';
import moment from 'moment-timezone'

class BusinessHoursSelection extends Component {
  state = {
    closed: false,
    startTimeError: false,
    endTimeError: false,
  };

  validateTimes = (startTime, endTime) => {
    const start = moment(startTime);
    const end = moment(endTime);
    return start.isBefore(end);
  }
  
  handleToggle = (event, checked) => {
    this.setState({ closed: checked });
    if (checked) {
      this.props.updateHour(this.props.dayOfWeek, "1970-01-01T00:00:00.000Z", "1970-01-01T00:00:00.000Z");
      this.setState({ startTimeError: false });
      this.setState({ endTimeError: false });
    } else {
      // Set hours to 9 AM to 5 PM in UTC
      const startTime = "1970-01-01T09:00:00.000Z";
      const endTime = "1970-01-01T17:00:00.000Z";
      this.props.updateHour(this.props.dayOfWeek, startTime, endTime);
    }
  };

  handleStartTimeChange = (e) => {
    const { dayOfWeek, hours, updateHour } = this.props;
    const newTime = e.target.value; // 'HH:mm' format

    // Parse the existing start_time as a moment object in UTC
    const currentDate = moment.tz(hours.start_time, "UTC");

    // Update the time part
    const [hoursPart, minutesPart] = newTime.split(':').map(Number);
    currentDate.hours(hoursPart);
    currentDate.minutes(minutesPart);

    // Get the updated time in ISO format with timezone as UTC
    const newISOTimeString = currentDate.toISOString();

    if (this.validateTimes(newISOTimeString, hours.end_time)) {
      updateHour(dayOfWeek, newISOTimeString, hours.end_time);
      this.setState({ startTimeError: false });
    } else {
      this.setState({ startTimeError: true });
    }
  }

  handleEndTimeChange = (e) => {
    const { dayOfWeek, hours, updateHour } = this.props;
    const newTime = e.target.value; // 'HH:mm' format

    // Parse the existing end_time as a moment object in UTC
    const currentDate = moment.tz(hours.end_time, "UTC");

    // Update the time part
    const [hoursPart, minutesPart] = newTime.split(':').map(Number);
    currentDate.hours(hoursPart);
    currentDate.minutes(minutesPart);

    // Get the updated time in ISO format with timezone as UTC
    const newISOTimeString = currentDate.toISOString();

    if (this.validateTimes(hours.start_time, newISOTimeString)) {
      updateHour(dayOfWeek, hours.start_time, newISOTimeString);
      this.setState({ endTimeError: false });
    } else {
      this.setState({ endTimeError: true });
    }
  }

  componentDidMount() {
    const { hours } = this.props;
    if (hours.start_time === hours.end_time) {
      this.setState({ closed: true });
    }
  }

  render() {
    const { dayOfWeek, hours } = this.props;
    const { closed, startTimeError, endTimeError } = this.state;
    const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const dayName = dayNames[dayOfWeek]; // Convert numeric day to string name

    const startTime = closed ? "00:00" : new Date(hours.start_time).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'UTC'  // Set timezone to UTC
    });

    const endTime = closed ? "00:00" : new Date(hours.end_time).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'UTC'  // Set timezone to UTC
    });

    return (
      <div>
        <div className="business-hours-selection">
          <label className="business-hours-selection__label">{dayName}</label>
          <div className="time-inputs">
            <input
              type="time"
              value={startTime}
              onChange={this.handleStartTimeChange}
              disabled={closed}
              className={startTimeError ? "input-error" : ""}
              step="900"  // Set step to 900 seconds for 15-minute increments
            />
            <span>-</span>
            <input
              type="time"
              value={endTime}
              onChange={this.handleEndTimeChange}
              disabled={closed}
              className={endTimeError ? "input-error" : ""}
              step="900"  // Set step to 900 seconds for 15-minute increments
            />
            <Toggle
              label="Closed"
              toggled={closed}
              onToggle={this.handleToggle}
            />
          </div>
        </div>
        {startTimeError && <div className="error-message">Start time must be before end time.</div>}
        {endTimeError && <div className="error-message">End time must be after start time.</div>}
      </div>
    );
  }
}

BusinessHoursSelection.propTypes = {
  dayOfWeek: PropTypes.number.isRequired,
  hours: PropTypes.shape({
    start_time: PropTypes.string,
    end_time: PropTypes.string
  }).isRequired,
  updateHour: PropTypes.func.isRequired
};

export default BusinessHoursSelection;



// WEBPACK FOOTER //
// ./src/components/sitewide/WeeklyHours/BusinessHoursSelection/index.js